module.exports = "/_next/static/images/associationLogo8-aa71ad128e57ea2b0106901fb9041cd4.webp";